export const GET_SUMMER_CAMPS_2026 = /* GraphQL */ `
  query getSummerCamps2026 {
    summer2026: products(
      category: "Lato"
      period: { start: "2026-01-01", end: "2026-12-31" }
    ) {
      ... on IProduct {
        sku
        name
        stock {
          available
        }
      }
    }
  }
`;

export const GET_WINTER_CAMPS_2027 = /* GraphQL */ `
  query getWinterCamps2027 {
    winter2027: products(
      category: "Zima 2027"
      period: { start: "2027-01-01", end: "2027-12-31" }
    ) {
      ... on IProduct {
        sku
        name
        stock {
          available
        }
      }
    }
  }
`;

export const GET_WINTER_CAMPS_2025 = /* GraphQL */ `
  query getNewWinterCamps2025 {
    adventure2025: products(
      category: "Adventure Winter"
      period: { start: "2026-01-01", end: "2026-12-31" }
    ) {
      ... on IProduct {
        sku
        name
        stock {
          available
        }
      }
    }

    master2025: products(
      category: "Master"
      period: { start: "2026-01-01", end: "2026-12-31" }
    ) {
      ... on IProduct {
        sku
        name
        stock {
          available
        }
      }
    }
  }
`;
